// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"PageLoader_loaderContainer__oL9bb","loader":"PageLoader_loader__1IX8y"};